import { TripStepTypes } from '../../lib/types/models/trip-booking/trip-step'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripStep(
  input: TripStepTypes.Request & { id: number; tripBookingId: number }
) {
  const { id, tripBookingId, ...data } = input
  return restApiClient
    .url(
      constructApiUrl(API['trip-bookings'].updateTripStep.url, {
        id: tripBookingId,
        tripStepId: id
      })
    )
    .patch<TripStepTypes.Full, TripStepTypes.Request>(data)
}
